// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_qIv","label":"styles_label__25KYA"};